import { gql } from "@apollo/client";

export const GET_ALL_ESTADO_PACIENTE = gql`
  query getAllEstadoPaciente {
    allEstadoPaciente {
      idEstadoPaciente
      codigo
      descripcion
    }
  }
`;

export const adaptEstadoPaciente = (estado) => {
  return {
    id: estado?.idEstadoPaciente,
    displayName: estado?.descripcion
  };
};

export const adaptEstadoPacienteArray = (estados) => {
  return structuredClone(estados)?.
  map((estado) => adaptEstadoPaciente(estado));
};